import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from './lang' // 引入 i18n 实例

import utils from "./utils";
Vue.prototype.$utils = utils

import ElementUI from "element-ui";
Vue.use(ElementUI);
import "element-ui/lib/theme-chalk/index.css";

import "./assets/css/reset.css"
import "./assets/iconfont/iconfont.css";

import LangSwitcher from '@/components/LangSwitcher.vue';
Vue.component('LangSwitcher', LangSwitcher)

import CustomSelect from '@/components/CustomSelect.vue';
Vue.component('CustomSelect', CustomSelect)

import PaginationView from "@/components/PaginationView.vue";
Vue.component('PaginationView', PaginationView)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
